export const PEPPER_ENTITIES = [
  {
    label: 'Pepper Content Private Limited',
    value: 'pepper_content_private_limited',
  },
  {
    label: 'Pepper Content Global Private Limited',
    value: 'pepper_content_global_private_limited',
  },
  { label: 'Pepper Content Inc.', value: 'pepper_content_inc' },
]
